import { Stack, Typography } from "@mui/material";
import SearchBar from "./SearchBar";
import FiltersOptions from "./FilterOptions";
import ModuleChip from "./ModuleChip";
import { useBoundStore } from "useStore";
import Buttons from "./Buttons";
import SubmitEditButtons from "../Table/SubmitEditButton";
import BrandFilter from "./BrandFilter";
import CategoryPathFilter from "./CategoryPathFilter";
import ProductMasterStats from "./Stats/ProductMasterStats";
import BrandFilterChip from "./BrandFilterChips";
import CategoryPathFiltersChip from "./CategoryPathFilterChip";
import DomainFiltersChip from "./DomainFilterChip";
import OwnerFiltersChip from "./OwnerFilterChip";
import FiltersColumns from "./FilterColumns";
import KamFilter from "./KamFilter";
import KamFilterChip from "./KamFilterChip";

export default function Toolbar({
  handleSentData,
  loading,
  rows,
  channelKeys,
}) {
  const modules = useBoundStore((state) => state.productMasterModules);
  const localChannels = useBoundStore((state) => state.localChannels);
  const setLocalChannels = useBoundStore((state) => state.setLocalChannels);
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      flexWrap="wrap"
      sx={{ marginBottom: "10px" }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        sx={{ width: "100%", gap: 2 }}
        gap={2}
        flexWrap="wrap"
      >
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
          flexWrap="wrap"
          sx={{ minHeight: "40px" }}
        >
          <SearchBar />
          <KamFilter />
          <BrandFilter />
          <CategoryPathFilter />
          {/* <DomainFilter /> */}
          <FiltersOptions />
        </Stack>
        <FiltersColumns />
      </Stack>
      <KamFilterChip />
      <BrandFilterChip />
      <CategoryPathFiltersChip />
      <DomainFiltersChip />
      <OwnerFiltersChip />
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        sx={{ width: "100%", gap: 2 }}
        gap={2}
        flexWrap="wrap"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
          flexWrap="wrap"
        >
          <Buttons
            rows={rows}
            localChannels={localChannels}
            channelKeys={channelKeys}
            setLocalChannels={setLocalChannels}
            handleSentData={handleSentData}
          />
          {/* <TableView /> */}
        </Stack>

        {Object.keys(localChannels).length > 0 && (
          <SubmitEditButtons
            loading={loading}
            handleSentData={handleSentData}
          />
        )}
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        sx={{ width: "100%" }}
        gap={2}
        flexWrap="wrap"
      >
        <ProductMasterStats />
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        sx={{ width: "100%", height: "24px" }}
        gap={2}
        flexWrap="wrap"
      >
        <Typography
          variant="body2"
          component="p"
          sx={{
            fontFamily: "Roboto",
            fontWeight: 500,
            fontSize: "16px",
            padding: "4px",
          }}
        >
          Modulos Afectados
        </Typography>
        {modules?.map((module, index) => (
          <ModuleChip title={module} key={index} />
        ))}
      </Stack>
    </Stack>
  );
}
